<template>
  <page>
          <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <message :messages="messages"></message>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-select v-model="form.report" :items="reportList" :label="labels.report" data-vv-name="report" :data-vv-as="labels.report" :error-messages="errors.collect('report')"
                    v-validate="'required'"  item-text="label" item-value="value" @change="reportTypeChanged"/>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-select v-model="form.acctPeriod" :items="acctPeriodList" :label="labels.acctPeriod" data-vv-name="acctPeriod" :data-vv-as="labels.acctPeriod" :error-messages="errors.collect('acctPeriod')"
                    v-validate="'required'" item-text="monthYearText" item-value="acctPerEndDate" />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select v-model="form.curr" :items="currItems" :label="labels.curr" data-vv-name="curr" :data-vv-as="labels.curr" :error-messages="errors.collect('curr')"
                    v-validate="'required'" item-text="currDesc" item-value="curr" />
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-3"></v-spacer>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
                <v-flex xs12>
                  <v-expansion-panels v-model="panel2" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div>
                        <v-icon>mdi-filter-variant</v-icon> Filters
                      </div>
                    </v-expansion-panel-header>
                      <v-expansion-panel-content>
                      <v-card>
                        <v-card-text>
                          <v-layout row wrap>
                            <v-flex xs12 sm6>
                              <v-text-field v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('branch')" data-vv-name="branch" :data-vv-as="labels.branch"
                                append-icon="mdi-magnify" readonly @click:append="showBranchHelpList = true" clearable v-validate="'required'"/>
                            </v-flex>
                            <v-flex xs12 sm6>
                              <v-text-field v-model="form.fund" :label="labels.fund" :error-messages="errors.collect('fund')" data-vv-name="fund" :data-vv-as="labels.fund"
                                append-icon="mdi-magnify" readonly @click:append="showFundHelpList = true" clearable v-validate="'required'"/>
                            </v-flex>
                            <v-flex xs12 sm6>
                              <v-text-field v-model="form.acctNoSfx" :label="labels.acctNoSfx" :error-messages="errors.collect('acctNoSfx')" data-vv-name="acctNoSfx" :data-vv-as="labels.acctNoSfx"
                                append-icon="mdi-magnify" readonly @click:append="showAcctNoSfxHelpList = true" clearable v-validate="'required'"/>
                            </v-flex>
                            <v-flex xs12 sm6></v-flex>
                        <v-flex xs12 sm6 v-if="form.report == 'pc'">
                          <v-text-field v-model="form.interFrom" :label="labels.interFrom" :error-messages="errors.collect('interFrom')" data-vv-name="interFrom" :data-vv-as="labels.interFrom"
                            append-icon="mdi-magnify" readonly @click:append="showIntermediaryHelpList = true;selectedInterField = 'interFrom'" clearable :disabled="form.report === 'rp'"
                            v-validate="valInterRange" />
                        </v-flex>
                        <v-flex xs12 sm6 v-if="form.report == 'pc'">
                          <v-text-field v-model="form.interTo" :label="labels.interTo" :error-messages="errors.collect('interTo')" data-vv-name="interTo" :data-vv-as="labels.interTo"
                            append-icon="mdi-magnify" readonly @click:append="showIntermediaryHelpList = true;selectedInterField = 'interTo'" clearable :disabled="form.report === 'rp'"
                            v-validate="valInterRange" />
                        </v-flex>
                          </v-layout>
                      </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  </v-expansion-panels>
                </v-flex>
                      </v-layout>
    </v-container>
    <v-flex xs12>
      <v-checkbox v-model="form.prtRptRunTime" :label="labels.prtRptRunTime" data-vv-name="prtRptRunTime"
        :data-vv-as="labels.prtRptRunTime" />
    </v-flex>
    <v-flex xs12>
      <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
        <v-icon left dark>mdi-file-export</v-icon>
        {{ labels.export }}
      </v-btn>
      <v-btn-toggle dense mandatory v-model="form.format">
        <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
          <span>{{ format.label }}</span>
          <v-icon :color="format.color">{{ format.icon }}</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-flex>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>
    <v-dialog v-model="showFundHelpList" width="900px" persistent>
      <multi-fund-help-list :fnd="form.fund" @close="showFundHelpList = false" @doAssign="doAssignFund($event)"></multi-fund-help-list>
    </v-dialog>
    <v-dialog v-model="showAcctNoSfxHelpList" width="900px" persistent>
      <multi-acct-no-sfx-help-list :acctNoSfx="form.acctNoSfx" @close="showAcctNoSfxHelpList = false" @doAssign="doAssignAcctNoSfx($event)"></multi-acct-no-sfx-help-list>
    </v-dialog>
    <v-dialog v-model="showIntermediaryHelpList" width="900px" persistent>
      <intermediary-help-list :interGrps="'10,11,13,20,25'" @close="showIntermediaryHelpList = false" headerInfo='default' @assign-intermediary-data="assignInterInfo"></intermediary-help-list>
    </v-dialog>
  </page>
</template>

<script>
import { reportFormat } from '@/const/report'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import MultiAcctNoSfxHelpList from '@/components/core/common/dialog/MultiAcctNoSfxHelpList.vue'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
export default {
  data() {
    return {
      labels: {
        report: 'Type of Report',
        acctPeriod: 'For Accounting Period',
        curr: 'Base Currency',
        branch: 'Branch',
        fund: 'Fund',
        acctNoSfx: 'Suffix',
        export: 'Export to',
        interFrom: 'Intermediary From',
        interTo: 'Intermediary To',
        prtRptRunTime: 'Print Runtime Parameters'
      },
      form: {
        report: 'pc',
        acctPeriod: undefined,
        curr: undefined,
        branch: 'All',
        fund: 'All',
        acctNoSfx: 'All',
        interFrom: undefined,
        interTo: undefined,
        format: 'PDF',
        prtRptRunTime: true
      },
      reportList: [
        { label: 'Premium and Commission', value: 'pc' },
        { label: 'Receipts and Payments', value: 'rp' }
      ],
      acctPeriodList: [],
      currItems: [],
      menu: {},
      supportedFormat: [],
      showBranchHelpList: false,
      showFundHelpList: false,
      showAcctNoSfxHelpList: false,
      showIntermediaryHelpList: false,
      selectedInterField: undefined,
      submitting: false,
      paginationCurr: {
        sortBy: [],
        sortDesc: [false],
        page: 1,
        itemsPerPage: 500 // get all, probably
      },
      panel: [0],
      hide: true,
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    valInterRange() {
      if (this.form.interFrom || this.form.interTo) {
        return 'required'
      }
      return ''
    },
    rptMenu() {
      return this.$store.state.reports.acctReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
  },
  methods: {
    async reportTypeChanged() {
      if (this.form.report === 'rp') {
        this.form.interFrom = undefined
        this.form.interTo = undefined
        this.form.acctPeriod = undefined
        this.form.curr = undefined
        this.form.branch = 'All'
        this.form.fund = 'All'
        this.form.acctNoSfx = 'All'
        this.hide = !this.hide
      } else {
        this.hide = !this.hide
      }
    },
    async doInit() {
      this.resetMessages()
      this.getAcctPeriods('3').then(result => {
        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth() + 1
        for (let acctPeriod of this.acctPeriodList) {
          if (acctPeriod.acctPerMth === month && acctPeriod.acctPerYr === year) {
            this.form.acctPeriod = acctPeriod.acctPerEndDate
          }
        }
      })
      this.fetchCurrData().then(res => {
        if (this.currItems) {
          for (let currItem of this.currItems) {
            currItem.currDesc = currItem.curr + ' - ' + currItem.currDesc
          }
        }
      })
      await this.$store.dispatch('acctReportsInit')
      const apiURI = this.rptMenu.gstReport
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.form.curr = data.companyCurr
            this.menu = extractMenu(result.data._links)
          }
        }
      } else {
        this.$toast.error('Missing API URI (GST Report)')
      }
    },
    async doAssignBranch(Obj) {
      this.form.branch = Obj.finalSelectedItems.toString()
      this.$validator.validate('branch')
    },
    async doAssignFund(Obj) {
      this.form.fund = Obj.finalSelectedItems.toString()
      this.$validator.validate('fund')
    },
    async doAssignAcctNoSfx(Obj) {
      this.form.acctNoSfx = Obj.finalSelectedItems.toString()
      this.$validator.validate('acctNoSfx')
    },
    async assignInterInfo(data) {
      switch (this.selectedInterField) {
        case 'interFrom':
          this.form.interFrom = data.inter
          this.$validator.validate('interFrom')
          break
        case 'interTo':
          this.form.interTo = data.inter
          this.$validator.validate('interTo')
          break
        default:
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    MultiBranchHelpList,
    MultiFundHelpList,
    MultiAcctNoSfxHelpList,
    IntermediaryHelpList
  }
}
</script>
